<div class="custom-datepicker-header">
  <span class="arrow" (click)="previousClicked()">
    <
  </span>
  <span class="custom-datepicker-label">{{ periodLabel }}</span>
  <span class="arrow" (click)="nextClicked()">
    >
  </span>
</div>
